import { createActionGroup } from '@ngrx/store';

export const CampagneSocieteCaracteristiqueActions = createActionGroup({
  source: 'Campagne Societe Caracteristique',
  events: {}
});
